export default __webpack_public_path__ + "static/media/logo_temple.1a676104.png";